/**
 * Utils Index
 *
 * Export all utility modules for easy importing
 */

export { default as secureStorage } from './secureStorage';
export * from './secureStorage';

export { default as apiValidation } from './apiValidation';
export * from './apiValidation';

export { default as errorHandler } from './errorHandler';
export * from './errorHandler';

/** Build version: git tag on production, date-sha on UAT, 'dev' locally. */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || 'dev';
